import { memo } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

// Components
import TabTitle from "../TabTitle";

// MUI
import { IconButton, Tab } from "@mui/material";
import { TabList } from "@mui/lab";

// Icons
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

function TabsContent(props) {
	const { tabs = [], errors, selected, tabsProps, handleChange, style } = props;

	return (
		<TabList
			style={style}
			className={clsx({
				"tab-selectable-container": true,
				[tabsProps?.tabClasses]: Boolean(tabsProps?.tabClasses),
			})}
			value={selected}
			variant={"scrollable"}
			scrollButtons={"auto"}
			allowScrollButtonsMobile
			aria-label="custom-tabs"
			onChange={handleChange}
			slots={{
				StartScrollButtonIcon: () => (
					<IconButton className="left-scroll" sx={{ padding: "2px" }}>
						<ChevronLeftRoundedIcon />
					</IconButton>
				),
				EndScrollButtonIcon: () => (
					<IconButton className="right-scroll" sx={{ padding: "2px" }}>
						<ChevronRightRoundedIcon />
					</IconButton>
				),
			}}
			{...tabsProps}
		>
			{tabs.map((tab, key) => {
				const itemKey = `selectable_tab_${key}`;
				let item, disabled;
				if (typeof tab === "object") {
					item = tab.title;
					disabled = tab.disabled;
				} else {
					item = tab;
					disabled = false;
				}

				return (
					<Tab
						disabled={disabled}
						key={itemKey}
						className={clsx({
							"!border !border-solid !border-b-0 !border-disabled !rounded-t-[6px] p-b-[0px] !min-h-[30px] !py-[0px]": true,
							"opacity-100 !bg-disabled": disabled,
						})}
						value={key}
						label={
							<TabTitle
								selected={selected === key}
								title={item}
								disabled={disabled}
								error={Boolean(errors?.[key])}
								badgeValue={tab.badgeValue}
							/>
						}
					/>
				);
			})}
		</TabList>
	);
}

const Selectors = memo(TabsContent);
export default Selectors;

TabsContent.propTypes = {
	tabs: PropTypes.array,
	errors: PropTypes.array,
	selected: PropTypes.number,
	tabsProps: PropTypes.shape({
		tabClasses: PropTypes.string,
	}),
	handleChange: PropTypes.func,
	style: PropTypes.object,
};

Selectors.propTypes = {
	tabs: PropTypes.array,
	errors: PropTypes.array,
	selected: PropTypes.number,
	tabsProps: PropTypes.shape({
		tabClasses: PropTypes.string,
	}),
	handleChange: PropTypes.func,
	style: PropTypes.object,
};
